/* unplugin-vue-components disabled */import script from "./car.vue?vue&type=script&setup=true&name=car&lang=js"
export * from "./car.vue?vue&type=script&setup=true&name=car&lang=js"

import "./car.vue?vue&type=style&index=0&id=35911401&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35911401"]])

export default __exports__